import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    ':last-child': {
      border: 'none',
    },
  },
  headerCell: {
    flex: 1,
    padding: theme.spacing(0, 0, 2, 0),
    color: theme.palette.labraText.description,
    fontSize: '12px',
    lineHeight: '16px',
  },
  cell: {
    flex: 1,
    padding: theme.spacing(2, 0),
    color: theme.palette.labraText.tertiary,
    fontSize: '16px',
    letterSpacing: '0.5px',
    lineHeight: '24px',
  },
  currency: {
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.labraText.description,
  },
  numberValue: {
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.tertiary,
    fontWeight: 400,
  },
}))
